import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UILink from 'UIComponents/link/UILink';
import { AssignTeamOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/fileOptions';
import { AutomationPlatformFlowProperties } from 'automation-ui-management/constants/CrmWorkflowProperties';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { useQuery } from 'data-fetching-client';
import { CRM_OBJECT_SEARCH_FIELD_NAME, CRM_OBJECT_SEARCH_BY_FLOW_ID } from 'automation-ui-management/queries/crmObjectQueries';
import getIn from 'immutable-less/transmute/getIn';
import { ReviewMetadataColumn, StyledMetadataValue } from 'automation-ui-canvas/containers/review/StyledMetadataDetails';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import TeamName from 'automation-ui-references/customer-data/TeamName';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TeamPermissionsMetadata = ({
  flow,
  handleOpenPanelWithRedirect
}) => {
  const {
    loading,
    data: flowCrmObjectByIdData
  } = useQuery(CRM_OBJECT_SEARCH_BY_FLOW_ID, {
    variables: {
      flowId: String(flow.flowId)
    }
  });
  const crmObject = getIn([CRM_OBJECT_SEARCH_FIELD_NAME], flowCrmObjectByIdData);
  const teamIds = crmObject && parseMultiEnumValue(getPropertyValue(crmObject, AutomationPlatformFlowProperties.TEAM_IDS)).map(val => Number(val)) || [];
  return /*#__PURE__*/_jsxs(ReviewMetadataColumn, {
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.detailsStep.permissions"
      })
    }), loading ? /*#__PURE__*/_jsx(SkeletonText, {}) : teamIds.length ? teamIds.map(teamId => {
      return /*#__PURE__*/_jsx(StyledMetadataValue, {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          maxWidth: 150,
          children: /*#__PURE__*/_jsx(TeamName, {
            id: teamId
          })
        })
      }, teamId);
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "platformReview.v2.detailsStep.permissionsAll"
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: () => {
        handleOpenPanelWithRedirect(AssignTeamOption.id);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.detailsStep.editPermissions"
      })
    })]
  });
};
export default TeamPermissionsMetadata;